import { render, staticRenderFns } from "./ProjectsTableDetailRowLayer.vue?vue&type=template&id=2a58bba5"
import script from "./ProjectsTableDetailRowLayer.vue?vue&type=script&lang=js"
export * from "./ProjectsTableDetailRowLayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports